import { _roundDec, _roundToDecimals } from "./_roundToDecimals";

export function _adjustInvestment(investment: number, step: number, precision?: number): number {
  // Проверяем, делится ли investment на step
  const remainder = _roundDec(investment % step, 2);
  // console.log('step', step);

  // console.log('remainder', remainder);
  // Если делится без остатка, возвращаем investment как есть
  if (remainder === 0) {
    return investment;
  }
  // Иначе, добавляем разницу до следующего кратного
  const adjustment = step - remainder;

  // console.log('adjustment', adjustment);
  // console.log('investment + adjustment', investment + adjustment);

  return investment + adjustment;
}
